import { PaperAnswer } from './paper-answer'
import { PaperReview } from './paper-review'

export interface ReflectionAnswerInterface {
  answers?: PaperAnswer[]
  reviews?: PaperReview[]
  /**
   * 答对题的数量
   */
  rightCount?: number
}

export class ReflectionAnswer implements ReflectionAnswerInterface {
  answers?: PaperAnswer[]
  reviews?: PaperReview[]
  /**
   * 答对题的数量
   */
  rightCount?: number

  constructor(props: ReflectionAnswerInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      answers: _answers,
      reviews: _reviews,
      rightCount: _rightCount,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.answers = _answers ? _answers.map((i) => new PaperAnswer(i)) : _answers
    this.reviews = _reviews ? _reviews.map((i) => new PaperReview(i)) : _reviews
    this.rightCount = _rightCount
  }
}
